import React from 'react';
import Modal from '../shared/Modal';

const ProductDeleteModal = props => {
  const { isOpen, closeModal, product, deleteProduct } = props;
  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <h2 className="h2 modal__heading">Delete Product</h2>
      <div className="form__row--spacer">
        <div className="modal__p">
          <p className="p">Are you sure you want to delete this product?</p>
        </div>
        <p className="p p--bold">Product Name</p>
        <p className="p">{product.name}</p>
      </div>
      <div className="form__row">
        <div className="form__row-item--half">
          <div
            className="btn btn--hollow-red-bright btn--full-width"
            onClick={closeModal}
          >
            Cancel
          </div>
        </div>
        <div className="form__row-item--half">
          <div
            className="btn btn--solid-red btn--full-width"
            onClick={deleteProduct}
          >
            Delete
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProductDeleteModal;



// WEBPACK FOOTER //
// ./src/components/product/ProductDeleteModal.js